import styled from 'styled-components'

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 20px;
  background: #F7F7F7;
  text-align: center;
`

export const Title = styled.h1`
  font-size: 20px;
  color: #373737;
  margin: 0px;
`

export const Message = styled.p`
  font-size: 14px;
  color: #808080;
  max-width: 420px;
  margin: 0px;
`
